/**
 * Create a function that returns incrementing numeric value
 *
 * Example:
 * ```
 * const getNextEntityId = createCounter(1);
 *
 * const createEntity = () => {id: getNextEntityId()};
 * ```
 */
export const createCounter =
  (start = 0) =>
  (): number =>
    // biome-ignore lint/style/noParameterAssign: unlocks trivial implementation there
    start++;
